import { LocalStorage } from "slotworks/services/storage/local-storage";

export class VStorage extends LocalStorage {
    public set(key: string, value: string | number | boolean) {
        if (value !== undefined) {
            V.API.Storage.setItem(this.getUniqueKey(key), value.toString());
        }
    }

    public getBoolean(key: string): boolean {
        const value: string = this.getKey(key);
        return value === "true" ? true : value === "false" ? false : null;

    }

    public getString(key: string): string {
        const value: string = this.getKey(key);
        return value;
    }

    public getNumber(key: string): number {
        const value = parseFloat(this.getKey(key));
        return isNaN(value) ? null : value;
    }

    private getKey(key: string) {
        return V.API.Storage.getItem(this.getUniqueKey(key));
    }
}
